import React, { Component } from "react";
import Dropzone from "react-dropzone";

// Components
import Modal from "../modal/Modal";
import Button from "../modal/Button";
import DropzoneAutomaticFile from "./DropzoneAutomaticFile";
import BlackButton from "../utils/BlackButton";

class DropzoneWrapperDocuments extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showError: false,
			files: [],
			allowMultiple: props.multiple !== undefined && props.multiple
		};
	}

	static getDerivedStateFromProps(props, state) {
		// If the files should be cleared, let's do that!
		if (props.clear) {
			return {
				files: []
			};
		}

		return state;
	}

	// ===================================================================================
	//  READ FILES
	// ===================================================================================
	onDrop = (acceptedFiles, rejectedFiles) => {
		// Log any rejected files for debugging if necessary
		if (rejectedFiles.length) {
			this.setState({ showError: true });
			console.log("Rejected:", rejectedFiles);
		}

		// If no accepted files, bail!
		if (!acceptedFiles.length) return;

		// Tell parent component to clear their files if necessary
		if (!!this.props.clearCurrentFiles) {
			this.props.clearCurrentFiles();
		}

		// If multiple files allowed, get all files.  If one file, get the first dropped file.
		const files = this.state.allowMultiple ? acceptedFiles : [acceptedFiles[0]];

		// Collect promises for each document read
		// Once complete, we will set the state with all images read.
		const promises = [];

		// Read all files
		files.forEach(file => {
			promises.push(this.readFile(file));
		});

		// Set the state all at once with all images read.
		// Once set, trigger the upload from the parent component.
		Promise.all(promises).then(files => {
			this.setState({ files }, () => this.props.handleFilesReadyToUpload(true));
		});
	};

	readFile(file) {
		return new Promise(resolve => {
			const reader = new FileReader();
			reader.onload = () => {
				const fileAsBinaryString = reader.result;
				file.fileString = fileAsBinaryString;

				// Let the parent component know that a file has been read/updated
				this.props.handleFileUpdate(this.props.name, file);

				// Return file the was read
				resolve(file);
			};

			reader.readAsBinaryString(file);
		});
	}

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		const { files } = this.state;

		return (
			<React.Fragment>
				<Dropzone
					onDrop={this.onDrop}
					accept="image/*, audio/*, application/pdf, text/plain, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
					multiple={!!this.props.multiple ? this.props.multiple : false}
					className="dropzone dropzone--files"
					disabled={!!files.filter(file => file.loading).length}
					disabledClassName="dropzone--files--disabled"
					activeClassName="dropzone--files--active"
				>
					{!!files.length &&
						files.map((file, i) => {
							return <DropzoneAutomaticFile key={i} file={file} />;
						})}
					<div className="txt">
						{this.props.placeholder
							? this.props.placeholder
							: `Drag files here or click to select files`}
					</div>
				</Dropzone>

				{/* Retry button */}
				{this.props.allowRetry && (
					<BlackButton clickHandler={this.props.retryHandler}>
						<span className="icon-keyboard_arrow_right" />
						Retry
					</BlackButton>
				)}

				{/* Show error */}
				{this.state.showError && (
					<Modal
						title={"Error"}
						buttons={[
							{
								type: Button,
								text: "Close",
								action: () => {
									this.setState({ showError: false });
								}
							}
						]}
					>
						Unable to read file. Please try using another.
					</Modal>
				)}
			</React.Fragment>
		);
	}
}

export default DropzoneWrapperDocuments;



// WEBPACK FOOTER //
// ./src/components/utils/DropzoneWrapperDocuments.js